import parseDialogue from "../../util/parseDialogue";

export const LeoRevisit = parseDialogue(`
leo:revisit:100-200

#100 Welcome back, kid. How's it going? I got just the software to make things easier for you out there. Wanna see?
>200 Sure, show me what you got.
>0 No thanks.
`);
